/**
 * Centralized site configuration, add whatever you need here.
 */
export default {
  siteTitle: "Morgan",
  siteDescription: "The AI intelligence layer for modern restructuring",
  siteUrl: "https://morgan.so",
  siteImage: "/images/og-image.png",
  favicon: "/favicon.ico",
  twitterHandle: "",
  email: "",
  address: "",
};
